import { siteNames } from '@seek/melways-sites';

import type { EmployerSiteName } from 'src/types/app';

type ANZSite =
  | typeof siteNames.employer.seek.au
  | typeof siteNames.employer.seek.nz;

export const isSiteAnz = (site: EmployerSiteName): site is ANZSite =>
  site === siteNames.employer.seek.au || site === siteNames.employer.seek.nz;
